/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-tools': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M7.563 1.25a6.125 6.125 0 00-3.375 1l4 4a1.312 1.312 0 01.124 1.875A1.313 1.313 0 016.438 8L2.313 4A6.15 6.15 0 001.25 7.563a6.337 6.337 0 006.313 6.312 6.812 6.812 0 001.625-.188l4.187 4.188a3.138 3.138 0 004.438-4.438L13.625 9.25a6.84 6.84 0 00.188-1.625 6.25 6.25 0 00-6.25-6.375zm5 6.313a4.777 4.777 0 01-.188 1.312l-.188.688.5.5 4.188 4.187a1.8 1.8 0 01.563 1.313 1.7 1.7 0 01-.563 1.312 1.813 1.813 0 01-2.625 0l-4.188-4.188-.5-.5-.687.188a4.756 4.756 0 01-1.313.188A5.169 5.169 0 014 11.124a4.769 4.769 0 01-1.5-3.563c0-.464.064-.927.188-1.375l2.75 2.75a2.587 2.587 0 003.687.126A2.587 2.587 0 009 5.374l-2.75-2.75a4.036 4.036 0 011.25-.188 5.17 5.17 0 013.563 1.438 5.306 5.306 0 011.5 3.688z"/>'
  }
})
